import React, { useState } from "react";
import Image from "next/image";
// import CustomIcon from "components/CustomIcon";
// import { Input } from "components/ResumeForm/Form/InputGroup";

interface DateInputSectionProps {
  startDate: string | undefined;
  endDate: string | undefined;
  dateIssueText: string | null;
  handleChange: (...args: any[]) => void;
}

export const DateInputSection: React.FC<DateInputSectionProps> = ({
  startDate,
  endDate,
  dateIssueText,
  handleChange,
}) => {
  // const [isAddDateOpen, setIsAddDateOpen] = useState(false);
  const [hasDateAdded, setHasDateAdded] = useState(false);
  const [isEditingDate, setIsEditingDate] = useState(false);
  
  return (
    <div className="flex items-center rounded-xl px-[6px] sm:px-[9px] py-[8px] sm:py-[10px] xl:p-[15px]"
      style={{ backgroundColor: isEditingDate || hasDateAdded ? "white" : "#F8F8F8" ,
        border: isEditingDate || hasDateAdded ? "3px solid #F8F8F8" : "3px solid #FFFFFF",
      }}
    >
      <div className="flex w-full items-center justify-start gap-[10px] sm:gap-[15px] lg:gap-[10px] xl:gap-[30px]">
        <div className="size-[16px] sm:size-[20px] lg:size-[20px] xl:size-[20px] py-[3px] sm:py-[5px] px-[3px] sm:px-[5px] bg-[#EDAD53] rounded-full">
          <Image
            src="/icons/duration.svg"
            width={15}
            height={15}
            alt="date"
            className="w-2 h-2 xl:w-4 xl:h-4"
          />
        </div>
        <span className="text-[10px] xs:text-xs sm:text-sm md:text-base lg:text-[10px] xl:text-[16px] font-montserrat text-black font-medium">
              { dateIssueText}
        </span>

        {/* Desktop: Show title and inputs separately */}
        {/* <div className="hidden lg:flex w-full items-center justify-start">
          {!hasDateAdded ? (
            <span className="text-[10px] xs:text-xs sm:text-sm md:text-base lg:text-[10px] xl:text-[16px] font-montserrat text-black font-medium">
              {isEditingDate ? "Edit duration" : dateIssueText}
            </span>
          ) : (
            <div className="flex w-full items-center justify-center gap-3">
              <Input
                label=""
                labelClassName="col-span-3"
                name="startDate"
                placeholder="June 2024"
                value={startDate}
                onChange={handleChange}
                disabled
              />
              <Input
                label=""
                labelClassName="col-span-3"
                name="endDate"
                placeholder="June 2024"
                value={endDate}
                onChange={handleChange}
                disabled
              />
            </div>
          )}
        </div> */}

        {/* Mobile: Show title OR inputs (inputs replace title when editing) */}
        {/* <div className="flex lg:hidden w-full items-center justify-start">
          {!isEditingDate && !hasDateAdded ? (
            <span className="text-xs xs:text-sm sm:text-base font-montserrat text-black font-medium leading-tight">
              {dateIssueText || "Duration missing"}
            </span>
          ) : !isEditingDate && hasDateAdded ? (
            <div className="flex w-full items-center justify-center gap-1">
              <Input
                label=""
                labelClassName="col-span-3"
                name="startDate"
                placeholder="June 2024"
                value={startDate}
                onChange={handleChange}
                disabled
              />
              <Input
                label=""
                labelClassName="col-span-3"
                name="endDate"
                placeholder="June 2024"
                value={endDate}
                onChange={handleChange}
                disabled
              />
            </div>
          ) : (
            <div className="flex w-full flex-col xs:flex-row items-center justify-center gap-1">
              <Input
                label=""
                labelClassName="col-span-3"
                name="startDate"
                placeholder="June 2024"
                value={startDate}
                onChange={handleChange}
              />
              <Input
                label=""
                labelClassName="col-span-3"
                name="endDate"
                placeholder="June 2024"
                value={endDate}
                onChange={handleChange}
              />
            </div>
          )}
        </div> */}
      </div>

      {/* Desktop editing inputs (when isAddDateOpen) */}
      {/* {isAddDateOpen && (
        <div style={{ visibility: hasDateAdded ? "hidden" : "visible" }}
          className="hidden lg:flex w-full items-center justify-center gap-3">
          <Input
            label=""
            labelClassName="col-span-3"
            name="startDate"
            placeholder="June 2024"
            value={startDate}
            onChange={handleChange}
          />
          <Input
            label=""
            labelClassName="col-span-3"
            name="endDate"
            placeholder="June 2024"
            value={endDate}
            onChange={handleChange}
          />
        </div>
      )} */}

      {/* Edit button */}
      {/* <button
        onClick={() => {
          setIsEditingDate(true);
          setHasDateAdded(false);
        }}
        className="rounded-full p-0.5 sm:p-0.75 lg:p-1 bg-white border shadow-md"
        style={{ visibility: hasDateAdded ? "visible" : "hidden" }}
      >
        <CustomIcon iconName="edit" className="w-3 h-3 sm:w-3.5 sm:h-3.5 lg:w-4 lg:h-4" />
      </button> */}

      {/* Add/Added button */}
      {/* <button
        onClick={() => {
          setIsAddDateOpen(true);
          setIsEditingDate(true);
          if (isAddDateOpen) {
            setHasDateAdded(true);
          }
        }}
        className={`rounded-lg flex items-center gap-1 ml-1 sm:ml-2 lg:ml-0 
          text-[10px] sm:text-[12px] lg:text-[10px] xl:text-[16px] shadow-xl transition-all duration-200 
          font-poppins font-medium text-[#458ef7] hover:bg-gray-100
          py-1 sm:py-1.5 lg:py-1 xl:py-1.5
          ${hasDateAdded 
            ? 'px-2 sm:px-2.5 lg:px-2 xl:px-3 bg-transparent' 
            : 'px-3 sm:px-6 lg:px-3 xl:px-9 bg-white'
          }`}
        disabled={hasDateAdded && !isEditingDate}
      >
        {hasDateAdded ? "Added" : "Add"}
        {hasDateAdded && (
          <CustomIcon iconName="greenTick" className="w-3 h-3 sm:w-4 sm:h-4 lg:w-3 lg:h-3 xl:w-4 xl:h-4" />
        )}
      </button> */}
    </div>
  );
};